<template>

    <div class="app-card" >
        <div class="head">
            <h3>{{ params.title }} </h3>
            <div class="icons">
                    <IconButton
                    v-if="true"
                    v-tooltip="`Execute this app`"
                    :icon="'play_circle'"
                    :width="32"
                    :height="32"
                    :type="'click'"
                    @click="startApp(params.name)"
                  />
            </div>
        </div>

        
        <img class="app-image" :src="imageURL" alt="Project Image"/>
        
        <div class="body__grid">

            <div class="body__grid-field">
                <div class="description">Description</div>
                <div class="value">{{ params.description }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Name</div>
                <div class="value">{{ params.name }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Version</div>
                <div class="value">{{ params.version }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Author</div>
                <div class="value">{{ params.author }}</div>
                </div>

                <div class="body__grid-field">
                <div class="description">Help</div>
                <a class="value" :href="params.docs">{{ params.docs }}</a>
                </div>
        </div>
        
        <div class="footer">
          <v-icon  v-tooltip:top-left="params.type" style="color:green;">{{ icon_name }}</v-icon>

          <div v-if="params.price>0" class="price">${{ params.price }} / hour</div>
          <div v-else class="price">Free</div>
        </div>
       
    </div>
    
</template>

<script setup>
import {ref, defineEmits,defineProps,computed } from 'vue';
import IconButton from '@/components/IconButton.vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import SVGIcon from '@/components/SVGIcon.vue';

const $toast = useToast();
const dataConnect = new DatastoreConnect();
const emit = defineEmits(['app_selected']);


const props = defineProps({
  params: {
    type: Object,
    required: true,
  },
});

const loading = ref(false);

function startApp(code) {
    emit('app_selected',code);
}


function formatTime(str) {
  return `${new Date(str).toLocaleTimeString('default', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true,
  })}`;
}

const imageURL = computed(() => {
    let url=`/resource/image?type=app&id=${props.params.id}`
    return url;

});

const icon_name = computed(() => {
  if (props.params.type=='import') return "mdi-import";
  if (props.params.type=='export') return "mdi-export";
  if (props.params.type=='train') return "mdi-chip";
  if (props.params.type=='test') return "mdi-cog";
  if (props.params.type=='data') return "mdi-database";

  return "mdi-check-bold";
});

</script>

<style lang="scss" scoped>
.app-card {
    min-width: 380px;
    min-height: 400px;
    max-width: 350px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: fit-content;
  padding: 8px ;
  text-align: left;
  overflow: hidden;
  border-radius: 8px;
  margin: 10px;
  border: 1px solid rgb(193, 193, 193);

  box-shadow: 2px 2px 6px 6px rgba(162, 162, 162, 0.2), 0 0 1px 1px rgba(0, 0, 0, 0.05);
}

.head {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}

.app-image {
  height: 180px;
  width: 100%;
  overflow: hidden;
  object-fit: contain;
}

.icons {
    margin-left: auto;
}

.footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

}

.price {
  border: 1px solid rgb(99, 114, 142);
  border-radius: 6px;
  padding: 0px 6px 0px 6px;
  align-self: flex-end;
  color: rgb(12, 59, 99);
  font-style: italic;
  place-self: end;
}
</style>